import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import analytics from './analytics';
import app from './app';
import api from './api';
import ticket from './ticket';
import loading from './loading';
import menu from './menu';
import auth from './auth';
import filter from './filter';
import notify from './notify';
import refresh from './refresh';
import attachments from './attachments';
import nativeLogging from './nativeLogging';
import { preloader as loadingBar } from './preloader';
import header from './header';
import help from './help';
import { reducers as appReducer } from '../../app/state';
import affilitesReducer from './affiliates';

import { reducer as affiliates } from '../../views/affiliates/AffiliateState';
import { reducer as requests } from '../../views/requests/RequestState';
import { reducer as requestDetail } from '../../views/requests/RequestDetailState';
import { reducer as layout } from '../../app/components/ResizeHandler';

const defaultState = {
  type: null,
};

const action = (state = defaultState, act) => Object.assign({}, state, {
  type: act.type,
});

const views = combineReducers({
  requests,
  requestDetail,
  affiliates,
});

const gemsReducers = combineReducers({
  app,
  action,
  analytics,
  loading,
  ticket,
  menu,
  api,
  auth,
  routing,
  filter,
  notify,
  refresh,
  attachments,
  loadingBar,
  nativeLogging,
  header,
  help,
  layout,
  views,

  session: appReducer,
  affiliates: affilitesReducer,
});

export default gemsReducers;



// WEBPACK FOOTER //
// ./src/state/reducers/index.js